import React, { Component } from 'react';
import { dateHelpers } from '../../../../../helpers';
import Anchor from "../../../../dashboardNew/objects/Anchor";

class MyJobItem extends Component {

  checkLength = field => {
    const { job } = this.props;
    const result = field && field.replace(/.{200}\S*\s+/g, "$&@").split(/\s+@/);
    return result[0] + ((job.title.length > 20) ? '...' : '');
  };

  render() {
    const {
      job,
      index,
      addJobToFavourites,
      removeJobFromFavourites,
      locationName,
      industryName,
      jobLogo
    } = this.props;

    const isExclusive = job.exclusive,
      isFavourite = job.favourite,
      salary =
        job.salary &&
        (job.salary.length > 35 || job.salary === "N/A" ? null : job.salary),
      title = this.checkLength(job.title),
      isPremium = job.premium_type === 1,
      isViewed = job.viewed;

    let colorClass = "";

    if (isExclusive) {
      colorClass = "exclusive";
    } else if (isPremium) {
      colorClass = "premium";
    } else {
      colorClass = "standard";
    }

    return (
      <div key={index} className="col-12 jobs-card">
        <div className="inner-card">

          {isPremium || isExclusive ? (
            <div className={`job-type ${colorClass}`}>
              {colorClass !== ('standard') &&
                <span className="job-type-title">
                  {isPremium ? "Premium/" : null}
                  {isExclusive ? "Exclusive" : null}
                </span>
              }
            </div>
          ) : null
          }

          <div className="col-12 col-lg-9 jobs-info">
            <div className="col-12 heading">
              <h3 className={`heading-three ${isViewed ? "viewed" : ""}`} dangerouslySetInnerHTML={{ __html: title }} />
            </div>

            <ul className="jobs-detail-list">
              <li className="jobs-detail-item">
                <span className="item-head">Job:</span> #{job.id}
              </li>
              <li className="jobs-detail-item">
                <span className="item-head">Closing date:</span> {dateHelpers.dateConverter(job.end_date)}
              </li>
              <li className="jobs-detail-item">
                <span className="item-head">Salary:</span> <span dangerouslySetInnerHTML={{ __html: salary }} />
              </li>
              {locationName &&
                <li className="jobs-detail-item">
                  <span className="item-head">Location:</span> {locationName.name}
                </li>
              }

            </ul>

            {industryName &&
              <div className="industry-body">
                <span className="industry-title">Industry</span>
                <span className="industry-item">{industryName.name}</span>
              </div>
            }
          </div>

          <div className="col-12 col-lg-3 jobs-side-info">
            <div className="info-image">
              {jobLogo && jobLogo ? (
                <img src={jobLogo} alt="company logo" className="image-logo" />
              ) : (
                  <img src="/images/job-placeholder.jpg" alt="job logo placeholder" className="image-logo default" />
                )
              }
            </div>
            <div className="info-button">
              <Anchor path={`/jobs/${job.id}`} anchorClass={`theme-button ${isViewed ? "secondary" : ""}`} internal>
                {isViewed ? "View Again" : "View Job"}
              </Anchor>
            </div>
            <div className="info-save">

              {/* {isFavourite ? (
                <button className="theme-favourite added" onClick={() => removeJobFromFavourites(job.id, index)}>
                  Remove from Favourites
                          <i className="fa fa-heart fav-icon" />
                </button>
              ) : (
                  <button className="theme-favourite" onClick={() => addJobToFavourites(job.id, index)}>
                    Add to Favourites
                          <i className="fa fa-heart fav-icon" />
                  </button>
                )} */}


            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default MyJobItem;



// WEBPACK FOOTER //
// src/client/components/site/features/jobs/pages/MyJobItem.js